import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import { DefaultUserManagersResponse } from 'services/requests';
import { QueryKeys } from 'constants/queryKeys';

export const useGetDefaultUserManagers = () => {
  const queryFn = () => async () => {
    const { data } = await api.getDefaultUserManagers();
    return data;
  };

  const queryKey = QueryKeys.defaultUserManagers;

  return useQuery<DefaultUserManagersResponse, AxiosError<ApiError>>(queryKey, queryFn());
};
